import React from "react";

function TermsOfService() {
  return <h1>Condiciones de Servicio</h1>;
}

export default TermsOfService;
